import { IEmployee } from '@widgets/EstimateInformation/model/types/types';

export const useAvatarsEmployeeList = (employees: IEmployee[]) => {
    const showEmployees = employees.slice(0, 4);
    const moreEmployees = employees.slice(4);

    const baseZIndex = employees.length + 1;

    return {
        showEmployees,
        moreEmployees,
        baseZIndex,
    };
};
